<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>الخطوط</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
              هنا يتم عرض جميع الخطوط
              <div v-show="$per.value.saveItineraries" class='pull-left' style='padding=0px'>
                <button @click='showForm(0)' type='button' class='btn btn-outline btn-primary btn-sm ' style='padding:3px;width: 80px' data-toggle='modal' data-target='#myModal'>
                  <b>  إضافة جديد </b>
                </button>
              </div>
            </div>
            <div class='form-group col-lg-12 col-sm-12'>
              <h4 >الفرع:</h4>
              <select class="form-control" v-model="branche">
                <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                <thead>
                  <tr>

                    <th style='text-align: center'>الفرع</th>
                    <th style='text-align: center'>الاسم</th>
                    <th style='text-align: center'>المحافظة</th>
                    <th style='text-align: center'>الاجراء</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class='odd gradeX' v-for='record in filteredProducts' :key='record.id'>
                    <td align='center'>{{record.bra}}</td>
                    <td align='center'>{{record.name}}</td>
                    <td align='center'>{{record.gov}}</td>
                    <td align='center'>
                      <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                      <button v-show="$per.value.deleteItineraries" @click='deleteData(record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                      <button v-show="$per.value.editItineraries" @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>تعديل</button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- Modal -->
    <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
      <div class='modal-dialog  modal-lg'>
        <div class='modal-content'>
          <div class='modal-header'>
            <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
            <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
          </div>
          <form role='form'>
            <div class='modal-body'>
              <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='alert alert-success alert-dismissable' v-if='successShow'>
                {{success}}
              </div>
              <fieldset>
                <div class='form-group col-lg-6 col-sm-6'>
                  <span>الفرع:</span>
                  <select class="form-control" style="padding: 0px" v-model="record.branch_id">
                    <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class='form-group col-lg-6 col-sm-6'>
                  <span>الاسم:</span>
                  <input v-model='record.name' class='form-control' name='branchname' type='text'>
                </div>
                <div class='form-group col-lg-6 col-sm-6'>
                  <span>المحافظة:</span>
                  <select class="form-control" style="padding: 0px" v-model="record.state">
                    <option v-for="(item) in governorates" v-bind:key="item.id" v-bind:value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </fieldset>
            </div>
            <div class='modal-footer'>
              <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
              <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
              <button @click='saveData' type='button' class='btn btn-primary'>حفظ</button>
            </div>
          </form>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- /.container-fluid -->
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'itineraries',
  data () {
    return {
      validationErrors: '',
      records: [],
      record: {},
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      governorates: [],
      branches: [],
      branche: '',
      title: ''
    }
  },
  computed: {
    filteredProducts () {
      return this.records.filter((item) => item.branch_id === Number(this.branche))
    }
  },
  created () {
    this.GetData()
    this.branche = localStorage.getItem('BrancheID')
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.branche = localStorage.getItem('BrancheID')
    this.governorates = JSON.parse(localStorage.getItem('Gov'))
  },
  methods: {
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getItineraries', {
        token: localStorage.getItem('token')
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        this.title = 'إضافة سجل جديد'
        this.record = {'id': 0, 'branch_id': '', 'name': '', 'state': ''}
      } else {
        this.title = 'تعديل بيانات سجل'
        this.record = {'id': recID.id, 'branch_id': recID.branch_id, 'name': recID.name, 'state': recID.state}
      }
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveItineraries', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        uid: this.record.uid,
        branch_id: this.record.branch_id,
        name: this.record.name,
        state: this.record.state
      })
        .then(res => {
          this.isLoadingSave = false
          if (this.record.id === 0) {
            this.records.push(res.data[0])
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          } else {
            let i = this.records.map(record => record.id).indexOf(this.record.id)
            this.records.splice(i, 1, res.data[0])
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'deleteItineraries', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(recID)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Lines.vue